export const OCC_PREFIX = '/occ/v2/';
export const ASSETS_PATH = '/assets/';
export const ASM_PATH = '/assistedservicewebservices/';
export const SESSION_ID_HEADER_NAME = 'x-rrs-session-id';
